// Module
var code = "<p>We use cookies to improve your browsing experience on our website and to analyze our website traffic. View our online <a href=\"/privacy-policy\" target=\"_blank\">Privacy Policy</a> for more information on our use of cookies. By selecting ACCEPT, you agree to our use of cookies.</p> ";
// Exports
export default code;